import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { TokenStorageService } from '../services/token-storage.service';
import { DataService } from '../services/data.service';
import { firstValueFrom } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

export const authGuard: CanActivateFn = async (route, state) => {
  const tokenStorage = inject(TokenStorageService);
  const dataService = inject(DataService);
  const router = inject(Router);
  const snackBar = inject(MatSnackBar);
  
  if (!tokenStorage.getToken()) {
    return router.createUrlTree(['/home']);
  }

  const isSubscriptionPage = state.url.includes('/account') && route.queryParams['tab'] === 'subscription';

  try {
    // Haal de abonnementsstatus op (pas de functienaam aan naar jouw DataService/UserService)
    const userSubscription = await firstValueFrom(dataService.getUserSubscription());

    const isSubscriptionActive = userSubscription.status === 'ACTIVE';

    if (!isSubscriptionActive) {
      // Is het abonnement verlopen?
      if (isSubscriptionPage) {
        return true; // Gebruiker probeert naar de abonnementspagina te gaan: laat door!
      }

      // Gebruiker probeert naar een andere pagina te navigeren: forward naar de abonnementspagina
      snackBar.open('Your subscription ended, you are redirected to the subscription page.', 'OK', { duration: 3000 });
      return router.createUrlTree(['/account'], { queryParams: { tab: 'subscription' } });
    }
  } catch (error) {
    console.error('Error checking subscription status:', error);
    // Optioneel: stuur bij een API-fout afhankelijk van je wensen door of laat blokkeren
  }

  return true;

};

export const adminAuthGuard: CanActivateFn = async (route, state) => {
  const dataService = inject(DataService);
  const tokenStorage = inject(TokenStorageService);
  const router = inject(Router);


  if (tokenStorage.getToken()) {
    const user = tokenStorage.getUser();
    if (user) {
      try {
        const roleData = await firstValueFrom(dataService.getRole());
        if (roleData && roleData.code === 'ADMIN') {
          return true;
        }
      } catch (error) {

      }

    }

  }

  // Niet ingelogd? Stuur naar home
  return router.createUrlTree(['/home']);

};